export default __webpack_public_path__ + "381c17570f323ca30384b161845010c7.png";